import { Pressable, ScrollView, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useJourney } from '../contexts/JourneyContext';
import ContentItemsList from '../elements/ContentItemsList';
import GeoTracking from '../elements/GeoTracking';

export default function ScreenClues(props) {
  const journey = useJourney();
  const location = props.location || journey.selectedLocation;

  return (
    <SafeAreaView style={{ flex: 1 }}>
      <View style={{alignItems: 'center'}}>
        <Pressable
          onLongPress={props.onComplete}
          delayLongPress={5000}
          style={{width: '100%'}}
        >
          <GeoTracking location={location} />
        </Pressable>
      </View>

      <ScrollView style={{flex: 1}} contentContainerStyle={{flexGrow: 1}}>            
        <ContentItemsList 
          contentItems={location.clues} 
          coverImage={location.icon || location.alt_name_1}
          completionButtonTapped={props.onComplete} 
          startedContent={props.startedClues}
          completionButtonLabel="I'm here"
        />
      </ScrollView>
    </SafeAreaView>
  );
}